import { render } from "./FinancialTransactions.vue?vue&type=template&id=ccf9974e"
import script from "./FinancialTransactions.vue?vue&type=script&lang=js"
export * from "./FinancialTransactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__